import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms'; 
import { ReactiveFormsModule } from '@angular/forms';

//import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
//import { } from 'bootstrap-icons'
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { environment } from '../environments/environment';

import {MatToolbarModule} from '@angular/material/toolbar';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSliderModule } from '@angular/material/slider';
import { MatCardModule } from '@angular/material/card';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSelectModule} from '@angular/material/select';
import {MatListModule} from '@angular/material/list';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
//import {MatToolbarModule} from '@angular/material/toolbar';

import { AppComponent } from './app.component';

// Services
import { AuthGuard } from './services/auth.guard';
import { AuthenticationService } from './services/authentication.service';
import { FirestoreService } from './services/firestore.service';
import { PeopleResolver } from './services/people.resolver';
import { PeopleService } from './services/people.service';
import { PeopleAddComponent } from './pages/people-add/people-add.component';
import { PeopleSignupComponent } from './pages/people-signup/people-signup.component';
import { PeopleLoginComponent } from './pages/people-login/people-login.component';
import { BusinessListComponent } from './pages/business-list/business-list.component';
import { BusinessDetailComponent } from './pages/business-detail/business-detail.component';
import { BusinessCategoryListComponent } from './pages/business-category-list/business-category-list.component';
import { PeopleDetailsComponent } from './pages/people-details/people-details.component';
import { PeopleUpdateDetailsComponent } from './pages/people-update-details/people-update-details.component';
import { PageHomeComponent } from './pages/page-home/page-home.component';
import { PageSearchComponent } from './pages/page-search/page-search.component';
import { PageHelpComponent } from './pages/page-help/page-help.component';
import { PageSettingComponent } from './pages/page-setting/page-setting.component';
import { SponsorListComponent } from './pages/sponsor-list/sponsor-list.component';
import { SponsorDetailComponent } from './pages/sponsor-detail/sponsor-detail.component';
import { SponsorProductDetailComponent } from './pages/sponsor-product-detail/sponsor-product-detail.component';
import { GovernmentListComponent } from './pages/government-list/government-list.component';
import { GovernmentDetailComponent } from './pages/government-detail/government-detail.component';
import { GovernmentCategoryListComponent } from './pages/government-category-list/government-category-list.component';
import { TourpackageListComponent } from './pages/tourpackage-list/tourpackage-list.component';
import { TourpackageDetailComponent } from './pages/tourpackage-detail/tourpackage-detail.component';
import { TourpackageCategoryListComponent } from './pages/tourpackage-category-list/tourpackage-category-list.component';
import { HandicraftListComponent } from './pages/handicraft-list/handicraft-list.component';
import { HandicraftDetailComponent } from './pages/handicraft-detail/handicraft-detail.component';
import { HandicraftCategoryListComponent } from './pages/handicraft-category-list/handicraft-category-list.component';
import { PaintingListComponent } from './pages/painting-list/painting-list.component';
import { PaintingDetailComponent } from './pages/painting-detail/painting-detail.component';
import { PaintingCategoryListComponent } from './pages/painting-category-list/painting-category-list.component';
import { NavsideSponsorComponent } from './components/navside-sponsor/navside-sponsor.component';
import { NavtopComponent } from './components/navtop/navtop.component';
import { NavsideAppsListComponent } from './components/navside-apps-list/navside-apps-list.component';
import { PopularBusinessListComponent } from './pages/popular-business-list/popular-business-list.component';
import { PopularBusinessCategoryListComponent } from './pages/popular-business-category-list/popular-business-category-list.component';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { ScrollableDirective } from './directives/scrollable.directive';
import { StoreProductListComponent } from './pages/store-product-list/store-product-list.component';
import { StoreProductDetailComponent } from './pages/store-product-detail/store-product-detail.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PrivacyPolicyComponent } from './pages/info/privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './pages/info/terms-conditions/terms-conditions.component';
import { GovernmentTerritoryListComponent } from './pages/government-territory-list/government-territory-list.component';
import { UploadPictureComponent } from './components/upload-picture/upload-picture.component';
import { MaxlengthNumberDirective } from './directives/maxlength-number.directive';
import { AdminBusinessDetailComponent } from './pages/admin-business-detail/admin-business-detail.component';
import { PlainTextOnlyDirective } from './directives/plain-text-only.directive';
//import { QuillModule } from 'ngx-quill';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { HttpClientModule } from '@angular/common/http';
import { AdminGovernmentDetailComponent } from './pages/admin-government-detail/admin-government-detail.component';
//import { PdfViewerModule } from 'ng2-pdf-viewer';


@NgModule({
  declarations: [
    AppComponent,
    PeopleAddComponent,
    PeopleSignupComponent,
    PeopleLoginComponent,
    BusinessListComponent,
    BusinessDetailComponent,
    BusinessCategoryListComponent,
    PeopleDetailsComponent,
    PeopleUpdateDetailsComponent,
    PageHomeComponent,
    PageSearchComponent,
    PageHelpComponent,
    PageSettingComponent,
    SponsorListComponent,
    SponsorDetailComponent,
    SponsorProductDetailComponent,
    GovernmentListComponent,
    GovernmentDetailComponent,
    GovernmentCategoryListComponent,
    TourpackageListComponent,
    TourpackageDetailComponent,
    TourpackageCategoryListComponent,
    HandicraftListComponent,
    HandicraftDetailComponent,
    HandicraftCategoryListComponent,
    PaintingListComponent,
    PaintingDetailComponent,
    PaintingCategoryListComponent,
    NavsideSponsorComponent,
    NavtopComponent,
    NavsideAppsListComponent,
    PopularBusinessListComponent,
    PopularBusinessCategoryListComponent,
    LoadingSpinnerComponent,
    ScrollableDirective,
    StoreProductListComponent,
    StoreProductDetailComponent,
    PrivacyPolicyComponent,
    TermsConditionsComponent,
    GovernmentTerritoryListComponent,
    UploadPictureComponent,
    MaxlengthNumberDirective,
    AdminBusinessDetailComponent,
    PlainTextOnlyDirective,
    AdminGovernmentDetailComponent,    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,

    //NgxBootstrapIconsModule,

    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    
    //Angular Material Component Modules
    MatToolbarModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatSliderModule,
    MatCardModule,
    MatSidenavModule,
    
    MatSelectModule,
    MatListModule,
    MatGridListModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    InfiniteScrollModule,
    NgbModule,

    //QuillModule.forRoot(),
    AngularEditorModule,
    HttpClientModule,
    //PdfViewerModule
  ],
  exports:[
  ],
  providers: [
    AuthGuard, 
    AuthenticationService, 
    FirestoreService, 
    PeopleResolver,
    PeopleService,
      
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
